'use strict';

var ClassUsageGridFilterFactory = function ClassUsageGridFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['FaresFilterByMarketFactory', 'FaresFilterByClassFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function ClassUsageGridFilter() {
    DemandFilter.call(this, 'fares-chart-mode', 'fares-class-usage-grid');
    this.registerFilters(injectedFilters);
  }
  ClassUsageGridFilter.prototype = Object.create(DemandFilter.prototype);
  ClassUsageGridFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  return ClassUsageGridFilter;
};
ClassUsageGridFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = ClassUsageGridFilterFactory;